import { render, staticRenderFns } from "./QuestionTypeSettings.vue?vue&type=template&id=09267740"
import script from "./QuestionTypeSettings.vue?vue&type=script&lang=js"
export * from "./QuestionTypeSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports